// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__s0ZLT","open":"Layout_open__MqSwa","backBlurBlock":"Layout_backBlurBlock__G+nNT"};